import React from 'react';

import { css, cx } from '@emotion/css';
import { Typography } from '@mui/material';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useStyles } from '@/hooks/useStyles.ts';
import { MedicationSchema } from '@/models/ConditionModel.ts';
import { Theme } from '@/theme/CreateTheme.ts';
import { DropDown } from '@/uiKit/molecules/ControlledDropDown.tsx';

export type TelemonitoringDurationFieldProps = {
  className?: string;
};

export const TelemonitoringDurationField: React.FC<
  TelemonitoringDurationFieldProps
> = ({ className }) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();
  const insulinScheme = useWatch({
    name: 'insulinScheme',
  }) as MedicationSchema | undefined;

  if (insulinScheme === 'noInsulin') {
    return null;
  }

  return (
    <div className={cx(styles.container, className)}>
      <Typography variant="subtitle">
        {t('diabetesForms.prescriptionDuration')}
      </Typography>
      <DropDown
        id="tls-duration-pick"
        classes={{
          root: styles.dropdown,
          dropdown: styles.durationDropdown,
        }}
        fieldName="duration"
        choices={['3', '2', '1'].map(value => ({
          displayName: `${value} ${t('diabetesForms.months')}`,
          value: value,
        }))}
      />
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css({}),
  dropdown: css({
    paddingTop: theme.spacing(12),
    paddingBottom: theme.spacing(12),
  }),
  durationDropdown: css`
    width: 100%;
  `,
});
